import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "upload-picture-container"
}

import { ref, toRefs } from 'vue'
import { getFileBlob } from '@/services/files.service'
import FileListHeader from '@/components/general/files/FileListHeader/FileListHeader.vue'
import FileList from '@/components/general/files/FileList/FileList.vue'
import FilePreview from '@/components/general/files/FilePreview.vue'
import FileUpload from './FileUpload/FileUpload.vue'
import { FILE } from '@/interfaces/misc.interface'

interface PROPS {
  fileList: (FILE | File)[]
  canDownloadAndPreviewFile: boolean
  canUpload?: boolean
}
interface EMITS {
  (e: 'addFile', newFile: File): void
  (e: 'removeFile', index: number): void
}

export default /*@__PURE__*/_defineComponent({
  __name: 'FileHandler',
  props: {
    fileList: {},
    canDownloadAndPreviewFile: { type: Boolean, default: true },
    canUpload: { type: Boolean, default: false }
  },
  emits: ["addFile", "removeFile"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const { fileList, canDownloadAndPreviewFile, canUpload } = toRefs(props)
const emits = __emit

const selectedFileIndex = ref(-1)
const selectedItemFileType = ref('')
const selectedFileUrl = ref('')
const selectedFile = ref<File | FILE | null>(null)
const isPreviewActive = ref(false)
let selectedFileName = ''

const addFile = (file: File) => {
  emits('addFile', file)
}
const removeFile = () => {
  if (selectedFileIndex.value === -1) return
  emits('removeFile', selectedFileIndex.value)
  selectedFileIndex.value = -1
  selectedFileUrl.value = ''
  selectedItemFileType.value = ''
  selectedFile.value = null
}
const downloadFile = async () => {
  if (selectedFileIndex.value === -1) return
  if (!selectedFileUrl.value.length) await setDownloadUrl()
  const fileLink = document.createElement('a')
  fileLink.href = selectedFileUrl.value
  fileLink.setAttribute('download', selectedFileName)
  document.body.appendChild(fileLink)
  fileLink.click()
}

const previewFile = async () => {
  if (!selectedFileUrl.value.length) await setDownloadUrl()
  isPreviewActive.value = true
}

const setDownloadUrl = async () => {
  try {
    const storageFileName = selectedFile?.value?.storageFileName
    if (storageFileName) {
      let endpoint
      if (storageFileName.includes('zdb-product-service')) {
        endpoint = `/${storageFileName}`
        selectedFileName = storageFileName.split('/').pop()
      } else {
        endpoint = `/documents/${storageFileName}`
        selectedFileName = selectedFile.value.name
      }
      const res = await getFileBlob(endpoint)
      const blob =
        selectedItemFileType.value === 'svg'
          ? new Blob([res.data], { type: 'image/svg+xml' })
          : new Blob([res.data])
      selectedFileUrl.value = window.URL.createObjectURL(blob)
    } else {
      selectedFileUrl.value = selectedFile?.value?.url
    }
  } catch (e) {
    console.error(e)
  }
}

const onSelectFile = async (file: File | FILE, index: number) => {
  selectedFileIndex.value = index
  if (file.storageFileName) {
    const dotIndex = file.storageFileName.lastIndexOf('.')
    selectedItemFileType.value = file.storageFileName.slice(dotIndex + 1)
    selectedFile.value = file
    URL.revokeObjectURL(selectedFileUrl.value)
    selectedFileUrl.value = ''
  } else {
    // Checks the index for the last . then slices so that we get the format of the file
    const dotIndex = file.url.lastIndexOf('.')
    selectedItemFileType.value = file.url.slice(dotIndex + 1)
    selectedFile.value = file
    URL.revokeObjectURL(selectedFileUrl.value)
    selectedFileUrl.value = ''
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(FileListHeader, {
      canUpload: _unref(canUpload),
      isFileSelected: selectedFileIndex.value !== -1,
      buttonsVisible: _unref(fileList).length > 0,
      canDownloadAndPreviewFile: _unref(canDownloadAndPreviewFile),
      onAddFile: addFile,
      onRemoveFile: removeFile,
      onPreviewFile: previewFile,
      onDownloadFile: downloadFile
    }, null, 8, ["canUpload", "isFileSelected", "buttonsVisible", "canDownloadAndPreviewFile"]),
    (!_unref(fileList).length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(FileUpload, { onUpload: addFile })
        ]))
      : (_openBlock(), _createBlock(FileList, {
          key: 1,
          selectedIndex: selectedFileIndex.value,
          files: _unref(fileList),
          onSelectFile: onSelectFile
        }, null, 8, ["selectedIndex", "files"])),
    (isPreviewActive.value)
      ? (_openBlock(), _createBlock(FilePreview, {
          key: 2,
          src: selectedFileUrl.value,
          type: selectedItemFileType.value,
          onClose: _cache[0] || (_cache[0] = ($event: any) => (isPreviewActive.value = false))
        }, null, 8, ["src", "type"]))
      : _createCommentVNode("", true)
  ]))
}
}

})